/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { FC, useState, useLayoutEffect } from 'react';
import { MdArrowUpward } from 'react-icons/md';

import { Flex, Box } from 'components/styled';

import { useLocalizedMultistring } from 'utils/localization';

const ScrollToTopButton: FC<{
	position?: 'absolute' | 'sticky';
}> = ({ position = 'sticky' }) => {
	const [showScroll, setShowScroll] = useState(false);
	const localize = useLocalizedMultistring();
	const scrollTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	useLayoutEffect(() => {
		const checkScrollTop = () => {
			if (!showScroll && window.pageYOffset > 50) {
				setShowScroll(true);
			} else if (showScroll && window.pageYOffset <= 50) {
				setShowScroll(false);
			}
		};

		window.addEventListener('scroll', checkScrollTop);
		return () => window.removeEventListener('scroll', checkScrollTop);
	}, [showScroll]);

	return (
		<Box
			css={css`
				border: none;
				padding: 0 10px 10px 0;
				position: ${position};
				margin-left: auto;
				margin-top: -70px;
				width: fit-content;
				bottom: ${position === 'sticky' ? 0 : 'unset'};
				display: ${showScroll ? 'flex' : 'none'};
				z-index: 999;
			`}
		>
			<Flex
				aria-label={localize({
					CZECH: 'skrolovat nahoru',
					ENGLISH: 'scroll to top',
				})}
				as="button"
				bg="rgba(0,0,0,0.5)"
				justifyContent="center"
				alignItems="center"
				onClick={scrollTop}
				css={css`
					border: none;
					color: white;
					border-radius: 50%;
					cursor: pointer;
					padding: 10px;
					margin: 0;
				`}
			>
				<MdArrowUpward size={40} />
			</Flex>
		</Box>
	);
};

export default ScrollToTopButton;
